export default __webpack_public_path__ + "static/media/ring5.25642e29.svg";